import { hasVersionedInlineGradient } from '../../../utils/textGradient';
import { getTextInnerGlow } from './getTextInnerGlow';
import { getTextDepth } from './getTextDepth';
import { hasGradient } from '@web-stories-wp/patterns';
import type { TextElement } from '../../types';
import { hasTextBorder } from './hasTextBorder';
import { hasMixedTypographyMarkers } from './mixedTypography';

export function shouldUseSvgTextFill({
  element,
  hasGradientFill = hasGradient(element.color),
  includeMixedTypography = false,
}: {
  element: TextElement;
  hasGradientFill?: boolean;
  includeMixedTypography?: boolean;
}) {
  return (
    (includeMixedTypography && hasMixedTypographyMarkers(element.content)) ||
    hasTextBorder(element.textBorder) ||
    Boolean(getTextInnerGlow(element.textInnerGlow)) ||
    Boolean(getTextDepth(element.textDepth)) ||
    Boolean(element.textTexture?.src) ||
    hasGradientFill ||
    hasVersionedInlineGradient(element.content)
  );
}

export function shouldSyncSvgTextWithHtml({
  element,
  hasSvgFill,
  isHighlight,
}: {
  element: TextElement;
  hasSvgFill: boolean;
  isHighlight: boolean;
}) {
  return (
    hasSvgFill && isHighlight && !hasMixedTypographyMarkers(element.content)
  );
}
